// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1r_O8","question":"Question_question__1RHTG","description":"Question_description__1P_pW"};